<template>
    <div class="introduce-box">
        <div class="marquee-text">
            <p class="toptext" v-if='textData[0]'>{{textData[0]}}</p>
            <p class="bottomtext" v-if='textData[1]'>{{textData[1]}}</p>
        </div>
        <div class="carBoxbottom" v-prlx='{reverse: true}'>
            <span class="title">Do Better. Together.</span>
            <h3 class="caption">为外贸品牌提供<br />更具优势的数字营销服务</h3>
            <p class="center">我们为外贸企业提供1+N式的一站式线上营销解决方案。</p>
            <p class="center">以海外独立站为"1"的基点，通过谷歌SEO、谷歌广告投放、邮件营销</p>
            <p class="center">海外社交媒体推广、视频营销等"N"的渠道吸引海量国外买家。</p>
        </div>
        <div class="carBox" v-prlx='{reverse: true}'>
            <span class="title">Do Better. Together.</span>
            <h3 class="caption">为外贸品牌提供<br />更具优势的数字营销服务</h3>
            <p class="center">我们为外贸企业提供1+N式的一站式线上营销解决方案。</p>
            <p class="center">以海外独立站为"1"的基点，通过谷歌SEO、谷歌广告投放、邮件营销</p>
            <p class="center">海外社交媒体推广、视频营销等"N"的渠道吸引海量国外买家。</p>
            <!-- 行走的线 -->
            <div class="animetionLine"></div>
        </div>
        <div class="carBanner">
            <span class="title">{{companyData.title}}</span>
            <h3 class="caption">{{companyData.caption}}</h3>
            <div class="center-box" v-for='(item,index) in companyData.chinese' :key='index' v-html='item'></div>
            <div class="englishText-box" v-html='companyData.english'></div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Introduce',
        props: {
            textData: Array,
            companyData: Object
        },
        data() {
            return {
                // textData: ['ENCOURAGE POSITIVE FEEDBACK SHARE', 'INNOVATION CULTIVATE INDUSTRY PROFESSIONAL'],
                // companyData: {
                //     chinese: ['<p class="text-center">我们拥有10年数字营销与网站设计开发经验、 100多项经典案例。</p><p class="text-center">我们的成员由数字营销策划、交互设计、数字前端及整合平台研发专家组成。</p>',
                //         '<p class="text-center">我们拥有10年数字营销与网站设计开发经验、 100多项经典案例。</p><p class="text-center">我们的成员由数字营销策划、交互设计、数字前端及整合平台研发专家组成。</p>'],
                //     english: '<p>Provide Google, social media, email marketing and other omni-channel applications, as well as enterprise training solutions and other full value chain</p><p>Provide Google, social media, email marketing and other omni-channel applications, as well as enterprise training solutions and other full value c</p>'
                // }
            }
        }
    }
</script>
<style scoped>
    .introduce-box {
        position: relative;
        padding-bottom: 286px;
        /* overflow: hidden; */
    }

    .marquee-text {
        padding-top: 63Px;
        position: relative;
        z-index: 2;
    }

    .marquee-text p {
        font-size: 150Px;
        font-weight: bold;
        line-height: 120%;
        white-space: nowrap;
        font-family: gilroybold4;
    }

    .marquee-text>p:first-child {
        color: #E5E5E5;
        margin-bottom: 15Px;
        animation: topToright 40s linear infinite;
    }

    .bottomtext {
        color: #F1F1F1;
        font-size: 150px;
        font-weight: bold;
        line-height: 120%;
        -webkit-text-stroke: 2px #E4E4E4;
        text-stroke: 2px #E4E4E4;
        animation: bottomToright 40s linear infinite;
    }

    .carBox {
        padding: 154px 69px 132px 100px;
        min-width: 770px;
        min-height: 640px;
        background: rgba(28, 28, 28, 0.9);
        position: absolute;
        top: -91px;
        right: 7.2%;
        z-index: 2;
    }

    .carBox::before {
        content: 'Blue  Whale';
        display: block;
        position: absolute;
        font-size: 14Px;
        font-weight: bold;
        color: rgba(229, 229, 229, 1);
        top: 0;
        right: 30Px;
        transform: rotate(90deg);
    }

    .animetionLine {
        width: 46Px;
        height: 14Px;
        position: absolute;
        top: 80Px;
        right: 44Px;
        transform: rotate(90deg);
        overflow: hidden;
        /* background-color:red; */
    }

    .animetionLine::after {
        content: '';
        display: block;
        transform: rotate(90deg);
        width: 1px;
        height: 46Px;
        background-color: #ffffff;
        position: absolute;
        top: -110%;
        right: 50%;
        animation: linearMotion 2.5s infinite;
    }

    .carBoxbottom {
        position: absolute;
        top: -91px;
        right: 7.2%;
        background: rgba(28, 28, 28, 1);
        padding: 154px 69px 132px 100px;
        min-width: 770px;
        min-height: 640px;
    }

    .title {
        font-size: 14Px;
        font-weight: 400;
        line-height: 128.5%;
        color: rgba(255, 255, 255, 1);
    }

    .caption {
        font-size: 32Px;
        font-weight: 400;
        line-height: 162.5%;
        color: rgba(255, 255, 255, 1);
        margin: 34Px 0 60Px 0;
    }

    .center {
        font-size: 16Px;
        font-weight: 300;
        line-height: 250%;
        color: rgba(229, 229, 229, 1);
    }

    .carBanner {
        width: 960Px;
        min-height: 610Px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border: 2px solid #333333;
        margin: 255Px auto 0;
    }

    .carBanner>.title {
        display: block;
        width: 100%;
        font-size: 14Px;
        font-weight: 400;
        line-height: 114.2%;
        color: rgba(51, 51, 51, 1);
        text-align: center;
    }

    .carBanner>.caption {
        text-align: center;
        font-size: 24Px;
        font-weight: bold;
        max-width: 70%;
        line-height: 142%;
        color: rgba(51, 51, 51, 1);
    }

    .center-box {
        max-width: 80%;
    }

    .center-box>>>p {
        font-size: 16Px;
        font-weight: bold;
        line-height: 187.5%;
        color: rgba(51, 51, 51, 1);
    }

    .center-box>>>p:not(:first-child) {
        margin-top: 38Px;
    }

    .center-box:not(:first-child) {
        margin-top: 32Px;
    }

    .englishText-box {
        margin-top: 30Px;
        max-width: 80%;
    }

    .englishText-box>>>p {
        font-size: 16Px;
        font-weight: 400;
        line-height: 214%;
        color: rgba(153, 153, 153, 1);
    }

    /* 跑马灯字幕 */
    @keyframes topToright {
        0% {
            transform: translateX(100%);
        }

        25% {
            transform: translateX(0%);
        }

        50% {
            transform: translateX(-25%);
        }

        75% {
            transform: translateX(-50%);
        }

        100% {
            transform: translateX(-100%);
        }
    }

    @keyframes bottomToright {
        from {
            transform: translateX(0%);
        }

        to {
            transform: translateX(-100%);
        }
    }

    /* 线条运动 */
    @keyframes linearMotion {
        from {
            right: 150%;
        }

        to {
            right: -52%;
        }
    }

    @media(max-width: 995px) {
        .marquee-text {
            display: none;
        }

        .carBox {
            min-width: 100%;
            min-height: auto;
            padding: 5%;
            position: relative;
            top: 0;
            right: 0;
        }

        .carBoxbottom,
        .carBox::before,
        .animetionLine {
            display: none;
        }

        .caption {
            margin: 0;
            margin-top: 5%;
            font-size: 24px;
        }

        .carBanner {
            width: 100%;
            min-height: auto;
            padding: 5%;
            border: none;
            margin: 0;
        }

        .carBanner>.title {
            font-size: 16px;
        }

        .carBanner>.caption {
            font-size: 24Px;
        }

        .center-box,
        .englishText-box {
            max-width: 100%;
        }

        .englishText-box {
            margin-top: 0;
        }

        .center-box>>>p:not(:first-child) {
            margin-top: 0;
        }

        .introduce-box {
            padding-bottom: 0;
        }


        /*

        .center-box,
        .englishText-box {
            max-width: 100%;
        }

        .center-box>>>p {
            font-size: 16Px;
        }

        .center-box>>>p:not(:first-child) {
            margin-top: 0;
        }

        .center-box:not(:first-child) {
            margin-top: 32Px;
        }

        .englishText-box>>>p {
            font-size: 16Px;
        }

        .introduce-box {
            padding-bottom: 80px;
        }
        .carBox::before{
            display: none;
        }
        .animetionLine {
        display: none;
    } */
    }

    /* @media(max-width: 1023px) {
        .carBanner {
            width: 80%;
        }

        .carBox {
            min-width: 352px;
            top: 0px;
            right: 0;
            left: 0;
        }

        .carBoxbottom {
            min-width: 352px;
            top: 0px;
            right: 0;
            left: 0;

        }

        .title {
            font-size: 50px;
        }

        .caption {
            font-size: 75px;
            line-height: 130%;
        }

        .center {
            font-size: 50px;
            line-height: 240%;
        }

        .carBox::before {
            display: none;
        }

        .animetionLine {
            display: none;
        }

        .carBanner {
            margin-top: 550px;
            margin-bottom: 0px;
        }

        .carBanner>.title {
            font-size: 50px;
            line-height: 200%;
        }

        .carBanner>.caption {
            margin: 0 auto;
            font-size: 75px;
            max-width: 82%;
            font-weight: bold;
            color: rgba(36, 136, 248, 1);
        }

        .center-box>>>p {
            font-size: 50px;
        }

        .englishText-box>>>p {
            font-size: 50px;
        }

        .marquee-text p {
            font-size: 280px;
        }
        .marquee-text {
        padding-top: 200px;
    }
    }
    @media(max-width: 375px){
        .carBanner {
            margin-top: 40%;
            margin-bottom: 0px;
        }
    } */
</style>


// WEBPACK FOOTER //
// src/components/main/home/introduce.vue